export default function({ itemName, data }) {
  localStorage.setItem(itemName, JSON.stringify(data));
}
